export const SUPABASE_PAGE_SIZE = 1000;
const MAX_PAGES = 50;

/** Busca todas as páginas de uma query PostgREST (limite padrão: 1000 linhas). */
export async function fetchAllPages<T>(
  fetchPage: (from: number, to: number) => PromiseLike<{ data: unknown; error: unknown }>,
): Promise<T[]> {
  const all: T[] = [];
  let from = 0;

  for (let page = 0; page < MAX_PAGES; page++) {
    const { data, error } = await fetchPage(from, from + SUPABASE_PAGE_SIZE - 1);
    if (error) throw error;
    const rows = (data ?? []) as T[];
    if (rows.length === 0) break;
    all.push(...rows);
    if (rows.length < SUPABASE_PAGE_SIZE) break;
    from += SUPABASE_PAGE_SIZE;
  }

  return all;
}

/** Insere linhas em lotes para evitar payloads grandes. */
export async function insertInBatches<T extends Record<string, unknown>>(
  table: { insert: (rows: T[]) => PromiseLike<{ error: unknown }> },
  rows: T[],
  batchSize = 500,
): Promise<void> {
  for (let i = 0; i < rows.length; i += batchSize) {
    const batch = rows.slice(i, i + batchSize);
    const { error } = await table.insert(batch);
    if (error) throw error;
  }
}
